module.exports = __webpack_public_path__ + "static/privacyCompute-cefd3014f8e8dc651fb6c7b598438ac2.mp4";